var Session = /** @class */ (function () {
    function Session() {
    }
    return Session;
}());
export { Session };
var AppSession = /** @class */ (function () {
    function AppSession() {
    }
    return AppSession;
}());
export { AppSession };
export var SessionTimerStatus;
(function (SessionTimerStatus) {
    SessionTimerStatus[SessionTimerStatus["START"] = 0] = "START";
    SessionTimerStatus[SessionTimerStatus["RESET"] = 1] = "RESET";
    SessionTimerStatus[SessionTimerStatus["STOP"] = 2] = "STOP";
})(SessionTimerStatus || (SessionTimerStatus = {}));
